import { BasicEntity } from "../../../core/models/basic-entity";

export class AddressType extends BasicEntity {

}
